var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloudIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.7,
    height: 25,
    viewBox: "492.2 1904 31.7 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171276132",
    "data-node-id": "6182:5243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-node-id": "6182:5244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-node-id": "6182:5245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    "data-node-id": "6182:5246",
    d: "M517.278 1912.74C517.212 1907.91 513.264 1904 508.421 1904C506.267 1904 504.191 1904.78 502.577 1906.21C501.137 1907.48 500.151 1909.17 499.761 1911.04C499.732 1911.04 499.704 1911.04 499.676 1911.04C495.538 1911.04 492.172 1914.4 492.172 1918.54C492.172 1922.68 495.538 1926.05 499.676 1926.05H504.916C505.289 1926.05 505.592 1925.74 505.592 1925.37C505.592 1925 505.289 1924.69 504.916 1924.69H499.676C496.283 1924.69 493.522 1921.93 493.522 1918.54C493.522 1915.15 496.283 1912.39 499.676 1912.39C499.857 1912.39 500.048 1912.4 500.26 1912.42C500.62 1912.45 500.943 1912.19 500.992 1911.84C501.236 1910.05 502.116 1908.41 503.47 1907.22C504.838 1906.01 506.596 1905.35 508.421 1905.35C512.56 1905.35 515.928 1908.72 515.928 1912.86C515.928 1913.01 515.917 1913.16 515.905 1913.32L515.9 1913.39C515.886 1913.59 515.961 1913.79 516.104 1913.92C516.246 1914.06 516.443 1914.13 516.641 1914.11C516.821 1914.09 517.002 1914.08 517.18 1914.08C520.105 1914.08 522.485 1916.46 522.485 1919.39C522.485 1922.31 520.105 1924.69 517.18 1924.69H511.669C511.296 1924.69 510.994 1925 510.994 1925.37C510.994 1925.74 511.296 1926.05 511.669 1926.05H517.18C520.85 1926.05 523.835 1923.06 523.835 1919.39C523.835 1915.75 520.902 1912.79 517.278 1912.74Z",
    fill: "#565656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-node-id": "6182:5247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-node-id": "6182:5248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    "data-node-id": "6182:5249",
    d: "M508.441 1907.17C505.618 1907.17 503.2 1909.28 502.819 1912.08C502.768 1912.45 503.027 1912.79 503.397 1912.84C503.428 1912.85 503.458 1912.85 503.489 1912.85C503.821 1912.85 504.111 1912.6 504.157 1912.26C504.448 1910.13 506.289 1908.52 508.441 1908.52C508.814 1908.52 509.116 1908.22 509.116 1907.85C509.116 1907.48 508.814 1907.17 508.441 1907.17Z",
    fill: "#565656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-node-id": "6182:5250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-node-id": "6182:5251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    "data-node-id": "6182:5252",
    d: "M511.491 1920.46L509.035 1918.27C508.611 1917.89 507.972 1917.89 507.549 1918.27L505.093 1920.46C504.814 1920.71 504.79 1921.14 505.039 1921.41C505.287 1921.69 505.714 1921.72 505.992 1921.47L507.617 1920.02V1928.32C507.617 1928.7 507.919 1929 508.292 1929C508.665 1929 508.967 1928.7 508.967 1928.32V1920.02L510.591 1921.47C510.72 1921.58 510.881 1921.64 511.041 1921.64C511.227 1921.64 511.411 1921.56 511.545 1921.41C511.793 1921.14 511.769 1920.71 511.491 1920.46Z",
    fill: "#565656"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudIcon);
export default __webpack_public_path__ + "static/media/uploadCloudIcon.59ad4a58f79b8723f7367dd01f09bb62.svg";
export { ForwardRef as ReactComponent };